import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AthleteLayout from "../common/AthleteLayout";
import { AthleteHeader } from "../common/AthleteHeader";
import greenClock from "../../images/greenClock.svg";
import strength1 from "../../images/strength1.png";
import strength2 from "../../images/strength2.png";

export const AthleteFreeStrengthWorkout = () => {
  const navigate = useNavigate();

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showPopup, setShowPopup] = useState(false);

  const changeDate = (days) => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + days);
      return newDate;
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
    });
  };

  const closePopup = () => setShowPopup(false);

  const strengthData = [
    {
      id: 1,
      name: "Box Squat",
      detail1: "4 sets x 8 reps, go up with every set",
      detail2: "60s rest between sets",
      path: strength1,
    },
    {
      id: 2,
      name: "Machine Leg Press",
      detail1: "4 sets x 8 reps, go up with every set",
      detail2: "60s rest between sets",
      path: strength2,
    },
    {
      id: 3,
      name: "Dumbbell Rear Foot Elevated Split Squat",
      detail1: "4 sets x 8 reps, go up with every set",
      detail2: "60s rest between sets",
      path: strength1,
    },
    {
      id: 4,
      name: "Leg Press Machine Calf Raise",
      detail1: "4 sets x 8 reps, go up with every set",
      detail2: "60s rest between sets",
      path: strength2,
    },
  ];

  const handleRowClick = (index) => {
    if (index !== 0) {
      setShowPopup(true);
    }
  };

  return (
    <AthleteLayout>
      <div className="h-full flex flex-col bg-white">
        {/* Header */}
        <div>
          <AthleteHeader />
        </div>

        {/* Date Controls */}
        <div className="w-full max-w-2xl mx-auto px-5">
          {/* <div className="py-3 flex flex-row justify-center items-center gap-10">
            <ArrowL onClick={() => changeDate(-1)} />
            <p className="text-black text-xl">{formatDate(selectedDate)}</p>
            <ArrowG onClick={() => changeDate(1)} />
          </div> */}

          {/* workout */}
          <div className="py-3 mb-3">
            <div className="bg-[#f5f4f4] rounded-2xl flex justify-between gap-8 px-3 xs:px-4 py-3 xs:py-4">
              <button className="text-black text-xl xs:text-2xl">
                Workout
              </button>
            </div>
          </div>

          {/* black header */}
          <div className="flex items-center gap-2 text-white w-full bg-black rounded-xl p-3">
            <p className="text-white text-sm xs:text-base">W1</p>
            <p className="text-white text-sm xs:text-base">|</p>
            <p className="text-white text-sm xs:text-base">
              {formatDate(selectedDate)}
            </p>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 overflow-y-auto bg-white">
          <div className="w-full max-w-2xl mx-auto">
            <div className="text-white py-3 bg-white">
              <div className="space-y-[15px] px-5">
                {strengthData.map((item, index) => (
                  <>
                    {/* <div
                    key={item.id}
                    onClick={() => handleRowClick(index)}
                    className={`flex flex-row gap-5 py-4 border-b-2 border-darkYellow cursor-pointer transition ${
                      index !== 0 ? "blur-sm pointer-events-auto" : ""
                    }`}
                  >
                    <div className="h-10 w-10 xs:h-14 xs:w-14 overflow-hidden flex-shrink-0">
                      <img
                        src={item.path}
                        alt="workout"
                        className="object-cover h-10 w-10 xs:h-14 xs:w-14"
                      />
                    </div>
                    <div className="flex flex-col gap-[6px]">
                      <p className="text-black text-base xs:text-lg font-bold leading-tight capitalize">
                        {item.name}
                      </p>

                      <div className="flex flex-col gap-1">
                        <p className="text-grayish font-medium text-sm xs:text-base leading-none">
                          {item.detail1}
                        </p>
                        <p className="text-grayish font-medium text-xs xs:text-sm">
                          {item.detail2}
                        </p>
                      </div>
                    </div>
                  </div> */}
                    <div
                      key={item.id}
                      onClick={() => handleRowClick(index)}
                      className={`w-full flex flex-row gap-3 xs:gap-5 py-4 border-b border-grayish/30 cursor-pointer transition ${
                        index !== 0 ? "blur-sm pointer-events-auto" : ""
                      }`}
                    >
                      <div className="border-l-2 border-darkYellow"></div>
                      <div className="flex flex-col">
                        <div className="flex items-start gap-4 xs:gap-5">
                          <div className="h-10 w-10 xs:h-14 xs:w-14 overflow-hidden flex-shrink-0">
                            <img
                              src={item.path}
                              alt="workout"
                              className="object-cover h-10 w-10 xs:h-14 xs:w-14"
                            />
                          </div>
                          <div className="flex flex-col gap-1">
                            <p className="text-black text-base xs:text-lg font-bold leading-tight capitalize">
                              {item.name}
                            </p>
                            <div className="flex flex-col gap-1">
                              <p className="text-grayish font-medium text-sm xs:text-base leading-none">
                                {item.detail1}
                              </p>
                              <p className="text-grayish font-medium text-xs xs:text-sm">
                                {item.detail2}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </div>

            {/* Popup */}
            {showPopup && (
              <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center p-3 z-50">
                <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full text-center">
                  <h2 className="text-black text-xl mb-3">
                    Your Training Starts Here.
                  </h2>
                  <p className="text-black font-medium mb-6">
                    Upgrade to an AMAX Remote membership and receive fully
                    personalized workouts every week.
                  </p>
                  <div className="flex justify-center gap-4">
                    <button
                      onClick={() => navigate("/athlete/membership")}
                      className="bg-black text-white font-medium text-xs xs:text-sm px-4 py-2 rounded hover:bg-black/70 transition"
                    >
                      View Memberships
                    </button>
                    <button
                      onClick={closePopup}
                      className="border border-gray-400 text-grayish font-medium text-xs xs:text-sm px-4 py-2 rounded hover:bg-grayish/10 transition"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </AthleteLayout>
  );
};

// --- Icons ---

const ArrowG = ({ onClick }) => (
  <svg
    onClick={onClick}
    className="hover:opacity-50 cursor-pointer"
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
  >
    <path
      d="M1 13L7 7L1 1"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowL = ({ onClick }) => (
  <svg
    onClick={onClick}
    className="hover:opacity-50 rotate-180 cursor-pointer"
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
  >
    <path
      d="M1 13L7 7L1 1"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Plus = () => {
  return (
    <svg
      width="24"
      className="w-full h-full"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0H24V24H0V0Z" fill="#C19E42" />
      <path d="M11 4.5H13V19.5H11V4.5Z" fill="black" />
      <path d="M4.5 13V11H19.5V13H4.5Z" fill="black" />
    </svg>
  );
};

const Minus = () => {
  return (
    <svg
      width="24"
      className="w-full h-full"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0H24V24H0V0Z" fill="#C19E42" />
      {/* <path d="M10.5 4H13.5V20H10.5V4Z" fill="black" /> */}
      <path d="M4.5 13V11H19.5V13H4.5Z" fill="black" />
    </svg>
  );
};
